import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Box,
  Typography,
  Grid,
  Paper,
} from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import BookingOverview from "./BookingOverview";
import GuestDetails from "./GuestDetails";
import PaymentDetails from "./PaymentDetails";
import {
  createCustomerTenancy,
  createTenancy,
  getCustomersByTenancyId,
  getTenancyById,
  updateTenancyById,
} from "../TenancyApi";
import { useEffect, useState } from "react";
import StayDetails from "./StayDetails";
import CheckoutDialog from "./CheckoutForm";
import RenewForm from "./RenewForm";
import Header from "../Header";
import ChangeRoomForm from "./ChangeRoomForm";

export default function BookingDetails() {
  const { tenancyId } = useParams();
  const [tenancyDetails, setTenancyDetails] = useState({});
  const [customersDetails, setCustomerDetails] = useState([]);
  const [showCheckoutForm, setShowCheckoutForm] = useState(false);
  const [showRenewForm, setShowRenewForm] = useState(false);
  const [showChangeRoomForm, setShowChangeRoomForm] = useState(false);


  // Local state for editable description
  const [description, setDescription] = useState("");
  const navigate = useNavigate();

  // ---------------- FETCHING DATA --------------------
  useEffect(() => {
    if (tenancyId) {
      getApiTenancyById(tenancyId);
      getApiCustomersByTenancyId(tenancyId);
    }
  }, [tenancyId]);

  const getApiCustomersByTenancyId = async (tenancyId) => {
    try {
      const response = await getCustomersByTenancyId(tenancyId);
      if (response) {
        setCustomerDetails(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getApiTenancyById = async (tenancyId) => {
    try {
      const response = await getTenancyById(tenancyId);
      if (response) {
        setTenancyDetails(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateApiTenancyById = async (tenancyId, body) => {
    try {
      const response = await updateTenancyById(tenancyId, body);
      if (response) {
        setTenancyDetails(response);

        // Sync local state again
        if (response.tenancyDescription) {
          setDescription(response.tenancyDescription);
        }
        return true;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  // Sync local description when tenancyDetails refreshes
  useEffect(() => {
    if (tenancyDetails) {
      setDescription(tenancyDetails.tenancyDescription || "");
    }
  }, [tenancyDetails]);

  // ---------------------- SAVE DESCRIPTION -----------------------
  const handleSaveDescription = () => {
    updateApiTenancyById(tenancyId, { tenancyDescription: description });
  };

  const handleCheckout = async(actualCheckoutDate, status) =>{
    const response = await updateApiTenancyById(tenancyId, {actualCheckoutDate, status})
    if(response){
      //Create a new Vacancy Tracking Request along with cleaning request
    }
  }
  const handleRenew = async(tempJson) =>{
    let tempTenancyDetails = structuredClone(tenancyDetails);
    updateApiTenancyById(tenancyId, {
      actualCheckoutDate: tenancyDetails.checkout,
      status:"checked-out"
    })
    delete tempTenancyDetails.id;
    tempTenancyDetails.checkin = tempJson.fromDate;
    tempTenancyDetails.checkout = tempJson.toDate;
    tempTenancyDetails.rate = tempJson.rate;
    tempTenancyDetails.rentalType = tempJson.rentalType;
    tempTenancyDetails.status = "active";

    const response = await createTenancy(tempTenancyDetails);
    if(response){
      for(let itr in customersDetails){
         const res = await createCustomerTenancy(response.data, customersDetails[itr].customerId);
      }
      navigate(`/booking/${response.data}`)
      
    }
  }

  const handleChangeRoom = async(roomNumber) =>{
    //Update
    //Update on sucess
    //API call to update new room vacancy ended to this date
    //create a new vacancy tracking for old room and raise cleaning ticket
    
  }

  return (
    <>
    <Header/>
    <a></a>
      {/* TOP BOOKING OVERVIEW TABLE */}
      <BookingOverview
        tenancyId={tenancyId}
        customersDetails={customersDetails}
        tenancyDetails={tenancyDetails}
      />

      {/* MAIN GRID */}
      <Grid container sx={{ p: 2 }} spacing={2}>
        {/* LEFT SIDE (3/4) */}
        <Grid item xs={12} md={9}>
          <GuestDetails tenancyId={tenancyId} customersDetails={customersDetails} />

          <br />

          {/* ------------------- STAY DETAILS ------------------- */}
          <StayDetails
            tenancyId={tenancyId}
            handleTenancyUpdate={updateApiTenancyById}
            tenancyDetails={tenancyDetails}
          />

          <br />

          {/* ------------------- PAYMENT DETAILS ------------------- */}
          <PaymentDetails
            tenancyId={tenancyId}
            tenancyDetails={tenancyDetails}
            customersDetails={customersDetails}
          />
        </Grid>

        {/* RIGHT SIDE */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={3}
            sx={{
              bgcolor: "white",
              px: 2,
              height: "100%",
              borderRadius: 1,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* DESCRIPTION */}
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: "0.95rem" }}>
                Notes / Description
              </Typography>

              <textarea
                style={{
                  width: "100%",
                  height: "120px",
                  resize: "none",
                  fontSize: "0.9rem",
                  borderRadius: "6px",
                  border: "1px solid #ddd",
                  outline: "none",
                }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Box>

            {/* ACTION BUTTONS (BEST ARRANGEMENT: 2×2 GRID) */}
            {tenancyDetails.status === "active" &&
            <Grid container spacing={1}>
              {/* SAVE BUTTON */}

              <Grid item xs={6}>
                <Paper
                  elevation={1}
                  sx={{
                    textAlign: "center",
                    py: 1,
                    fontWeight: 600,
                    bgcolor: "#eef6ff",
                    color: "#0066ff",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#e2efff" },
                  }}
                  onClick={handleSaveDescription}
                >
                  Save
                </Paper>
              </Grid>

              <Grid item xs={6}>
                <Paper
                  elevation={1}
                  sx={{
                    textAlign: "center",
                    py: 1,
                    fontWeight: 600,
                    bgcolor: "#eef6ff",
                    color: "#0066ff",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#e2efff" },
                  }}
                  onClick={()=>setShowCheckoutForm(true)}
                >
                  Checkout
                </Paper>
              </Grid>

              <Grid item xs={6}>
                <Paper
                  elevation={1}
                  sx={{
                    textAlign: "center",
                    py: 1,
                    fontWeight: 600,
                    bgcolor: "#eef6ff",
                    color: "#0066ff",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#e2efff" },
                  }}
                  onClick={()=>setShowRenewForm(true)}
                >
                  Renew
                </Paper>
              </Grid>

              <Grid item xs={6}>
                <Paper
                  elevation={1}
                  sx={{
                    textAlign: "center",
                    py: 1,
                    fontWeight: 600,
                    bgcolor: "#eef6ff",
                    color: "#0066ff",
                    cursor: "pointer",
                    "&:hover": { bgcolor: "#e2efff" },
                  }}
                  onClick={()=>setShowChangeRoomForm(true)}

                >
                  Change Room
                </Paper>
              </Grid>
            </Grid>}
          </Paper>
        </Grid>
      </Grid>
      {showCheckoutForm && <CheckoutDialog open={showCheckoutForm}
        onClose={()=>setShowCheckoutForm(false)}
        tenancyDetails={tenancyDetails}
        handleCheckout={handleCheckout}
      />}
      {showRenewForm && <RenewForm open={showRenewForm}
        onClose={()=>setShowRenewForm(false)}
        tenancyDetails={tenancyDetails}
        handleRenew={handleRenew}
      />}
      {showChangeRoomForm && <ChangeRoomForm open={showChangeRoomForm}
      onClose={()=>setShowChangeRoomForm(false)}
      tenancyDetails = {tenancyDetails}
      handleChangeRoom = {handleChangeRoom}
      />}
    </>
  );
}
